export default {
  REMOTE: 'Télétravail',
  IN_OFFICE: 'Présentiel',
  COWORKING: 'Coworking',
  ABSENT: 'Absent',
  WORK_MODE: 'Mode de travail',
  ERROR_ADD_ON_DAY_OFF: 'La date sélectionnée coïncide avec un congé',
  CALENDAR_NOTES:
    'Pour modifier un badge de mode de travail, cliquez dessus ou ajoutez-en un nouveau en cliquant sur une date libre.',
  LOCKED_TITLE: 'Modification bloquée',
  LOCKED_MESSAGE: 'Les modifications sont verrouillées',
  LOCK_SUCCESS: 'Cadenas activé avec succès',
  UNLOCK_SUCCESS: 'Cadenas désactivé avec succès',
  LOCK_ERROR: 'Erreur lors de la modification du cadenas',
  LOCK_BUTTON_TOOLTIP: 'Cliquez pour {state} le cadenas',
  LOCKED_STATE: 'verrouillé',
  UNLOCKED_STATE: 'déverrouillé',
  CALENDAR_BUTTON: 'Calendrier',
  LOCK_TOOLTIP: 'Avec l\'activation de ce bouton, le collaborateur ne peut plus modifier ses jours de présence et d\'absence depuis sont profil.',
  UNLOCK_TOOLTIP: 'Avec l\'activation de ce bouton, le collaborateur peut à nouveau modifier ses jours de présence et d\'absence depuis sont profil.',
  LOCKED_BY_MESSAGE: 'Calendrier verrouillé',
  LOCKED_MODE_TOOLTIP: 'Mode de travail verrouillé - contactez un administrateur pour modifier',  
  UPDATE_SUCCESS: 'Mode de travail mis à jour avec succès',
  UPDATE_ERROR: 'Erreur lors de la mise à jour du mode de travail',
  ERROR_CHECKING_LOCK: 'Erreur lors de la vérification du statut du cadenas',
  USER_NOT_FOUND: 'Utilisateur non trouvé',
  ADMIN_ONLY: 'Seuls les administrateurs peuvent modifier le statut du cadenas',
  ERROR_FETCHING_DATA: 'Erreur lors de la récupération des modes de travail',
  ERROR_FETCHING_DAYS_OFF: 'Erreur lors de la récupération des jours de congés',
  VIEW_ONLY_MODE: 'Mode lecture seule - Vous ne pouvez pas modifier ce calendrier',
  SCHEDULE: 'Horaires habituelles'
}
